import {useState, memo} from 'react'
import {Checkbox, Link} from '@components/lib'
import {useTranslation} from 'react-i18next'

import {useLogout, useTermsCondition} from 'hooks'
import {docSlugs, getDocExternalLink} from 'views/Documents/Documents.config'

import {TermsModal, CheckboxWrapper, CheckboxTexts, CloseButton} from './ModalTermsCondition.styles'

const ModalTermsCondition = () => {
  const {t} = useTranslation()
  const logout = useLogout()
  const [checkBox, setCheckBox] = useState(false)
  const {submitTermsCondition, submitTermsConditionLoading, isModalState} = useTermsCondition()

  return (
    <TermsModal
      isOpened={isModalState}
      title={'Terms and Condition'}
      maxWidth='450px'
      onClose={logout.mutate}
    >
      <h1>Terms and Condition</h1>
      <CheckboxWrapper>
        <Checkbox
          name='agree_terms'
          value={checkBox}
          onChange={() => setCheckBox(preState => !preState)}
        />
        <CheckboxTexts>
          {t('forms.checkboxes.agreeTerms')} {t('forms.checkboxes.agreeTerms')}{' '}
          <Link
            href={getDocExternalLink(docSlugs.userTermsAndConditions, t)}
            text={t('documents.termsAndConditions.title')}
            size='sm'
            target='_blank'
          />
        </CheckboxTexts>
      </CheckboxWrapper>
      <CloseButton
        text={t('documents.buttonText')}
        disabled={!checkBox}
        isLoading={submitTermsConditionLoading}
        onClick={submitTermsCondition}
      />
    </TermsModal>
  )
}

export default memo(ModalTermsCondition)
